import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { PageComponentModule } from '../../../cms-structure';
import { provideDefaultConfig } from '../../../core/config';
import { MediaModule, PuffCollectionPaginationComponent } from '../../../shared';
import { PuffCollectionComponent } from './puff-collection.component';

@NgModule({
  imports: [CommonModule, MediaModule, PageComponentModule, PuffCollectionPaginationComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        PuffCollectionComponent: {
          component: PuffCollectionComponent,
        },
      },
    }),
  ],
  declarations: [PuffCollectionComponent],
  exports: [PuffCollectionComponent],
})
export class CmsPuffCollectionModule {}
